import { StaticProfileConfig } from '@lemontaps/lib/types/api';
import { Button, Stack } from '@mui/material';

interface Props {
  imprint?: StaticProfileConfig['footer']['imprint'];
  privacyPolicy?: StaticProfileConfig['footer']['privacyPolicy'];
}

export default function Policies({ imprint, privacyPolicy }: Props) {
  return (
    <Stack direction='row' spacing={2} justifyContent='center' alignItems='center'>
      {imprint && (
        <Button variant='text' href={imprint.url} target='_blank' rel='noopener noreferrer'>
          {imprint.label}
        </Button>
      )}

      {privacyPolicy && (
        <Button variant='text' href={privacyPolicy.url} target='_blank' rel='noopener noreferrer'>
          {privacyPolicy.label}
        </Button>
      )}
    </Stack>
  );
}
